"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReCaptchaInstance = (function () {
    function ReCaptchaInstance(siteKey, recaptcha) {
        this.siteKey = siteKey;
        this.recaptcha = recaptcha;
        this.styleContainer = null;
    }
    ReCaptchaInstance.prototype.execute = function (action) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.recaptcha.execute(_this.siteKey, { action: action }).then(resolve, reject);
        });
    };
    ReCaptchaInstance.prototype.getSiteKey = function () {
        return this.siteKey;
    };
    ReCaptchaInstance.prototype.hideBadge = function () {
        if (this.styleContainer !== null)
            return;
        this.styleContainer = document.createElement('style');
        this.styleContainer.innerHTML = '.grecaptcha-badge{display:none !important;}';
        document.head.appendChild(this.styleContainer);
    };
    ReCaptchaInstance.prototype.showBadge = function () {
        if (this.styleContainer === null)
            return;
        document.head.removeChild(this.styleContainer);
        this.styleContainer = null;
    };
    return ReCaptchaInstance;
}());
exports.ReCaptchaInstance = ReCaptchaInstance;
